import React from 'react';
import { TouchableOpacity, Animated, StyleSheet, View, Text, ScrollView, Pressable, Easing, Switch, GestureResponderEvent  } from 'react-native';
// import { TouchableOpacity,  } from 'react-native-gesture-handler';
import { FontAwesome, AntDesign, Ionicons, Entypo, Foundation, FontAwesome5, Feather, } from '@expo/vector-icons';
import {SortableGrid, SortableContainer, SortableTile,} from '../C_Drag/index';
import {Connection, ConnectionOrd, ConnectionMkt, ConnectionRMS, ConnectionHis} from '../~Utilities/Connection';
import Utilities from '../~Utilities/Utilities';
import TextNC from '../C_Text/TextNC';
import ReleaseNotes from './ReleaseNotes';
import TextPC from '../C_Text/TextPC';
import { AppMain, FontInfo, UTheme } from '../~Utilities/Constants';
import {StringTable} from '../StringTable';
import SvgDarkMode, { SvgSortAZ, SvgSortZA } from '../C_General/ImagesSvg';
import ACC from '../~Screens/ACC';
import { TextInput } from 'react-native-gesture-handler';
import * as Clipboard from 'expo-clipboard';
import * as Device from 'expo-device';
import SwitchNE from '../C_Text/SwitchNoError';

var oSettAlt     : Array<any>  | null;
const DEFAULT_WIDTH   = 350;
const DEFAULT_OPACITY = 0.4;

const AnimatedPressable = Animated.createAnimatedComponent(Pressable);

export interface IReOrderEx
{
  bindEvent       : (onEvent    : (() => void), 
                     bSubscribe : boolean) => void,

}

/*   ---------------------------------------------------------------------   */

export interface IReOrderState
{
  visible        : boolean | null;
  update         : number;
  shown_count    : number;
  tab            : number;
  show_reorder   : boolean;
  scroll_enabled : boolean;
  AnimLeft       : Animated.Value; 
  AnimOp         : Animated.Value;
}

/*   ---------------------------------------------------------------------   */

export default class ReOrderEx extends React.Component<IReOrderEx>
 {
    public static MSG_SIGN_OFF = 1;
    public static MSG_SEARCH   = 2;
    public static MSG_ABOUT    = 3;

    public static TAB_EDIT     = 0;
    public static TAB_SETTINGS = 1;
    public static TAB_USER     = 2;
    public static TAB_HELP     = 3;

    public        OnPopupMsg : ((iMsg : number) => void) | null = null;
    public        oSymList   = Connection.oSettings;
    public        oNC        = new Array<TextNC | null>(0);
    public        oPC        = new Array<TextPC | null>(0);

    public        oTimer    : NodeJS.Timer | null = null;
    // public        oDelTimer : NodeJS.Timer | null = null;

    private      bReset      = false;
    private      scrollRef   : ScrollView | null  = null;
    // private      oNotes     : ReleaseNotes | null = null;

    /*   -------------------------------------------------------------------   */

    ScrollToPage(iPage : number)
    {
    this.scrollRef?.scrollTo({x: iPage * 285, animated:true});  
    }

    /*   -------------------------------------------------------------------   */

    Reset()
    {
      this.bReset = true;
    }

    /*   -------------------------------------------------------------------   */

    ReOrder()
    {
      if (oSettAlt != null)
        {
        if (__DEV__)          
          Utilities.Sendlog("reordering...");  
        //oSettings = oSettAlt;
  
        let   oStoreLocal = new Map();
          
        for (let i = 0; i < oSettAlt.length; i++)
            oStoreLocal.set(oSettAlt[i].token,
                            ConnectionMkt.oStore.get (oSettAlt[i].token));
  
  
        ConnectionMkt.oStore = oStoreLocal;
        //oSettAlt  = null;
        }
    }
  
  /*   -------------------------------------------------------------------   */

    CloseModal(bCommit = true, 
               bClose  = true)
    {
    if (bCommit && oSettAlt != null)
      {
      //this.ReOrder();

      let   oStoreLocal = new Map();
          
      for (let i = 0; i < oSettAlt.length; i++)
          oStoreLocal.set(oSettAlt[i].token,
                          ConnectionMkt.oStore.get (oSettAlt[i].token));

  
      //alert("apply reorder 0");
      ConnectionOrd.ApplyReOrder(oStoreLocal, oSettAlt);                          
      //ConnectionOrd.oSettings = oSettAlt;
      //ConnectionOrd.SaveSettings()
      //this.forceUpdate();
      }
  
    oSettAlt  = null;
  
    if (bClose == true)
      this.Hide();
    }
  
  /*   -------------------------------------------------------------------   */
    
   Show()
   {
    this.oSymList = Connection.GetSymbols(ConnectionMkt.oSettings, 0);

    //alert("show : " + this.state.visible);  
    
    if (this.bReset)
      {
      this.setState({visible:true,
                     //  del_index:AppMain.IMAGINARY, 
                    tab: AppMain.iDef_Sett_Page, //ReOrderEx.TAB_EDIT,
                    update: 0,
                    shown_count: this.state.shown_count + 1,
                    });

      this.bReset = false;
      //this.ScrollToPage(ReOrderEx.TAB_EDIT);
      }
    else
      this.setState({visible:true,
                    //  del_index:AppMain.IMAGINARY, 
                    //tab:this.iPage,
                    tab: AppMain.iDef_Sett_Page, //ReOrderEx.TAB_EDIT,
                    update: 0,
                    shown_count: this.state.shown_count + 1,
                    });

    //this.state.AnimLeft.setValue(-DEFAULT_WIDTH);

    //this.forceUpdate
    this.SlideIn();

    if (this.oTimer)
      {
      clearInterval(this.oTimer);
      this.oTimer = null;
      }

    this.oTimer = setInterval(this.OnTime, 1000);
   }

  /*   -------------------------------------------------------------------   */

  OnTime()
  {
  //eco dis
  //if (ConnectionMkt.bEco == false)
    //Utilities.Sendlog("ReOrder: getting image snapshot...");  
  if (this.state.tab == ReOrderEx.TAB_EDIT)
    {
    ConnectionMkt.GetImages();

    for (let i = 0; i < this.oNC.length; i++)
      {
      this.oNC[i]?.UpdateData();
      this.oPC[i]?.UpdateData();
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  Hide()
  {
  //ConnectionOrd.SaveAppSettings();

  //this.setState({visible:false})
  this.SlideOut();

  if (this.oTimer)
    {
    clearInterval(this.oTimer);
    this.oTimer = null;
    }

  if (this.state.shown_count >= 2)
    {
    ConnectionOrd.RequestReview();
    }
  }

  /*   -------------------------------------------------------------------   */

  HideNoAnimation()
  {
  oSettAlt = null;

  if (this.state.visible == true)
    this.setState({visible:false})

  if (this.oTimer)
    {
    clearInterval(this.oTimer);
    this.oTimer = null;
    }
  }

/*   -------------------------------------------------------------------   */

    Toggle()
    {
    if (this.state.visible == true)
      this.Hide();
    else
      {
      this.Show();
      }
    //this.setState({visible:!this.state.visible})
    }

  /*   -------------------------------------------------------------------   */

  state : IReOrderState = {visible:null,
                           update: 0,
                           shown_count: 0,
                           show_reorder:true,
                           scroll_enabled:true,
                           tab: ReOrderEx.TAB_EDIT,
                              // del_index:AppMain.IMAGINARY,
                           AnimLeft: new Animated.Value(-DEFAULT_WIDTH), 
                           AnimOp: new Animated.Value(0)};

  /*   -------------------------------------------------------------------   */

   
  constructor(props)
  {
  super(props);

  this.state            = {visible:null, 
                           update: 0,
                           shown_count: 0,
                           show_reorder:true,
                           scroll_enabled:true,
                           tab: ReOrderEx.TAB_EDIT,
                          //  del_index:AppMain.IMAGINARY,
                           AnimLeft:new Animated.Value(-DEFAULT_WIDTH),
                           AnimOp: new Animated.Value(0)};
                           
  this.Show             = this.Show.bind(this);
  this.Hide             = this.Hide.bind(this);
  this.HideNoAnimation  = this.HideNoAnimation.bind(this);
  this.ReOrder          = this.ReOrder.bind(this);
  this.CloseModal       = this.CloseModal.bind(this);
  this.GetNC            = this.GetNC.bind(this);
  this.GetNCPure        = this.GetNCPure.bind(this);
  this.GetPC            = this.GetPC.bind(this);
  this.OnTime           = this.OnTime.bind(this);
  this.renderTop        = this.renderTop.bind(this);
  this.renderSettings   = this.renderSettings.bind(this);
  this.renderHelp       = this.renderHelp.bind(this);
  this.renderUser       = this.renderUser.bind(this);
  this.renderEdit       = this.renderEdit.bind(this);
  this.renderSortable   = this.renderSortable.bind(this);
  this.onDragEnd        = this.onDragEnd.bind(this);
  this.TurnPage         = this.TurnPage.bind(this);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.oPC.splice(0, this.oPC.length);
  this.oNC.splice(0, this.oNC.length);

  if (this.oTimer)
    {
    clearInterval(this.oTimer);
    this.oTimer = null;
    }
  }

  /*   -------------------------------------------------------------------   */

   SlideIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(this.state.AnimLeft, {
      toValue: -40,
      duration: 300,
      easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();

    Animated.timing(this.state.AnimOp, {
      toValue: DEFAULT_OPACITY,
      duration: 300,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();    
  };

  /*   -------------------------------------------------------------------   */

  SlideOut = () => {
    // Will change fadeAnim value to 0 in 3 seconds
    Animated.timing(this.state.AnimLeft, {
      toValue: -DEFAULT_WIDTH,
      duration: 100,
      useNativeDriver:true
    }).start(()=>{ this.setState({visible:false}) });

    Animated.timing(this.state.AnimOp, {
      toValue: 0,
      duration: 100,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();        
  };

  /*   -------------------------------------------------------------------   */

  GetNC(sToken : string)
  {
  let oData = ConnectionMkt.oStore.get(sToken);

  if (oData == undefined)
    return("");
  else
    {
    if (oData.nc < 0)
      return(ConnectionMkt.getFmt(oData.nc, oData));
    else
      return("+" + ConnectionMkt.getFmt(oData.nc, oData));
    }
  }

  /*   -------------------------------------------------------------------   */

  GetPC(sToken : string)
  {
  let oData = ConnectionMkt.oStore.get(sToken);

  if (oData == undefined)
    return("");
  else
    {
    if (oData.nc < 0)
      return(oData.pc.toFixed(2));
    else
      return("+" + oData.pc.toFixed(2));
    }
  }

    /*   -------------------------------------------------------------------   */

  GetNCPure(sToken : string)
  {
  let oData = ConnectionMkt.oStore.get(sToken);

  if (oData == undefined)
    return('green');
  else
    {
    if (oData.nc < 0)
      return('crimson');
    else
      return('green');
    }
  }

  /*   -------------------------------------------------------------------   */

  TurnPage(iPage : number)
  {
    this.setState({tab:iPage});

    AppMain.iDef_Sett_Page = iPage;
    ConnectionOrd.SaveAppSettings();
  }

  /*   -------------------------------------------------------------------   */

  renderTop()
  {
    return(
    <View style={{//position:'absolute', bottom:0, left:0, width:'100%',
      marginTop:-30,
      minHeight:40, paddingVertical:0, alignItems:'center', justifyContent:'flex-end', 
      backgroundColor:'rgba(0, 0, 0, .7)', 
      borderTopEndRadius:25, flexDirection:'row'}}>


    <TouchableOpacity style={{flexDirection:'row', backgroundColor:this.state.tab==ReOrderEx.TAB_EDIT? 'cornflowerblue' : 'transparent', minWidth:30, minHeight:30, borderRadius:15,
              alignItems:'center', justifyContent:'center', marginRight:15}}//position:'absolute', bottom:0, left:0, width:'100%',
              onPress={ ()=> {this.TurnPage(ReOrderEx.TAB_EDIT) } } >

    {/* <FontAwesome style={{ marginBottom: -1 }} name="edit" size={20} color="white" /> */}
    <Foundation name="pencil" size={20} color="white" />
    {/* <FontAwesome name="pencil" size={20} color="white" /> */}
    {/* <Octicons name="pencil" size={20} color="white" /> */}
    {/* <SimpleLineIcons name="pencil" size={20} color="white" /> */}
    </TouchableOpacity>

    <TouchableOpacity style={{flexDirection:'row', backgroundColor:this.state.tab==ReOrderEx.TAB_SETTINGS? 'cornflowerblue' : 'transparent', minWidth:30, minHeight:30, borderRadius:15,
              alignItems:'center', justifyContent:'center', marginRight:15}}//position:'absolute', bottom:0, left:0, width:'100%',
              onPress={ ()=> {this.TurnPage(ReOrderEx.TAB_SETTINGS) } } >

    <Ionicons name="settings-outline" style={{}} size={20} color="white" />
    </TouchableOpacity>


    <TouchableOpacity style={{flexDirection:'row', backgroundColor:this.state.tab==ReOrderEx.TAB_USER? 'cornflowerblue' : 'transparent', minWidth:30, minHeight:30, borderRadius:15,
              alignItems:'center', justifyContent:'center', marginRight:15}}//position:'absolute', bottom:0, left:0, width:'100%',
              onPress={ ()=> {this.TurnPage(ReOrderEx.TAB_USER) } } >


    {/* <Ionicons name="settings-outline" style={{}} size={20} color="white" /> */}
    <AntDesign name="user" size={19} color="white" />
    </TouchableOpacity>


    <TouchableOpacity style={{flexDirection:'row', backgroundColor:this.state.tab==ReOrderEx.TAB_HELP? 'cornflowerblue' : 'transparent', minWidth:30, minHeight:30, borderRadius:15,
              alignItems:'center', justifyContent:'center', marginRight:15}}//position:'absolute', bottom:0, left:0, width:'100%',
              onPress={ ()=> {this.TurnPage(ReOrderEx.TAB_HELP) } } >


    {/* <Ionicons name="settings-outline" style={{}} size={20} color="white" /> */}
    <Entypo name="help" size={19} color="white" />
    </TouchableOpacity>

    <TouchableOpacity style={{flexDirection:'row', backgroundColor:'#d14d4d', minWidth:30, minHeight:30, borderRadius:15,
              alignItems:'center', justifyContent:'center', marginRight:25}}//position:'absolute', bottom:0, left:0, width:'100%',
            //marginTop:-30,
            //minHeight:50, paddingVertical:10, alignItems:'center', justifyContent:'flex-end', 
            //backgroundColor:'rgba(0, 0, 0, .8)', 
            //borderTopEndRadius:20, flexDirection:'row'}}
            onPress={ ()=>
                { 
                  //this.CloseModal(false);
                  this.HideNoAnimation();

                  if (this.OnPopupMsg) 
                    this.OnPopupMsg(ReOrderEx.MSG_SIGN_OFF) 
                } } 
            >
    <FontAwesome style={{ marginBottom: -1 }} name="power-off" size={20} color="white" />
    {/* <MaterialCommunityIcons style={{ marginBottom: -1 }} name="location-exit" size={22} color="rgba(255, 255,255, .8)" /> */}
    {/* <AntDesign name="logout" size={20} color="white" /> */}
    {/* <Text style={{fontSize:16, fontWeight:'bold',
    color:'white', 
    paddingLeft:4,
    marginRight:30,
    marginLeft:5}}>Sign Out
    </Text> */}
    </TouchableOpacity>
    </View>

    );
  }

  /*   -------------------------------------------------------------------   */

  renderSettings()
  {
  const SIZE=30;

  if (this.state.tab != ReOrderEx.TAB_SETTINGS)
    return(null);
  else
    return(
        // <>

        <ScrollView scrollsToTop={true} 

        style={{//alignSelf:'center', //height:'50%',
                //marginTop:10, //flexDirection:'row', 
                backgroundColor:'transparent', 
                marginBottom:20, 
                //width:285,
                }}
        contentContainerStyle={{alignItems:'center', justifyContent:'center'}}>

        {/* <View style={{marginLeft:40, marginTop:20, alignSelf:'center', flexDirection:'column', alignItems:'center',
                      backgroundColor:'rgba(255,255,255,.0)', borderRadius:20, width:150}}> */}

        <View style={{marginLeft:40, marginTop:20, alignSelf:'center', flexDirection:'column', alignItems:'center',
                      backgroundColor:'rgba(255,255,255,.0)', borderRadius:20, }}>

        <Text style={[FontInfo.appStyles.txt_bold, {fontSize:16, marginTop:5, color:'rgba(255,255,255,.9)'}]}>Background</Text>
        <View style={{marginTop:15, marginBottom:10, opacity:1, zIndex:2002, backgroundColor:'transparent',  flexDirection:'row'}}>
      
          {/* <Pressable style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Blue?'#04cd25':'transparent', 
                                    backgroundColor:'#7b68ee', width:SIZE, height:SIZE, marginRight:6}}
            onPress={()=>
            {
              alert()
              ConnectionOrd.ChangeTheme(UTheme.Blue);
            }}>
          </Pressable> */}

          <TouchableOpacity style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Blue?'#04cd25':'transparent', 
                                    backgroundColor:'#7b68ee', width:SIZE, height:SIZE, marginRight:6}}
            onPress={()=>
            {
              //alert()
              ConnectionOrd.ChangeTheme(UTheme.Blue);
            }}>
          </TouchableOpacity>

          <TouchableOpacity style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Green?'#04cd25':'transparent', 
                                    backgroundColor:'lightgreen', width:SIZE, height:SIZE, marginRight:6}}
            onPress={()=>
            {
              ConnectionOrd.ChangeTheme(UTheme.Green);
            }}>
          </TouchableOpacity>
          
      
          <TouchableOpacity style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Gray?'#04cd25':'transparent', 
                                    backgroundColor:'darkslategray', width:SIZE, height:SIZE, marginRight:6}}
            onPress={()=>
            {
              ConnectionOrd.ChangeTheme(UTheme.Gray);
            }}>
          </TouchableOpacity>
      
          <TouchableOpacity style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Metal?'#04cd25':'transparent', 
                                    backgroundColor:'grey', width:SIZE, height:SIZE, marginRight:6}}
            onPress={()=>
            {
              ConnectionOrd.ChangeTheme(UTheme.Metal);
      
            }}>
          </TouchableOpacity>
      
          <TouchableOpacity style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Multi?'#04cd25':'transparent', 
                                    backgroundColor:'violet', width:SIZE, height:SIZE}}
            onPress={()=>
            {
              ConnectionOrd.ChangeTheme(UTheme.Multi);
      
            }}>
          </TouchableOpacity>      

          {/* <TouchableOpacity style={{borderRadius:SIZE/2, 
                                    borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Multi?'#04cd25':'transparent', 
                                    backgroundColor:'violet', width:SIZE, height:SIZE}}
            onPress={()=>
            {
              ConnectionOrd.ChangeTheme(UTheme.Multi);
      
            }}>
          </TouchableOpacity>                 */}
          
          </View>


          <Text style={[FontInfo.appStyles.txt_bold, {fontSize:16, marginTop:15, marginBottom:10, color:'rgba(255,255,255,.9)'}]}>Transparency</Text>
          <View style={{backgroundColor:'transparent', justifyContent:'center', marginBottom:15, alignItems:'center', alignContent:'center', flexDirection:'row'}}>
          {/* <Feather name="eye" size={22} color={FontInfo.bTransparency? 'yellow':'lightgray'} /> */}
          <AntDesign name="eyeo" size={23} color={FontInfo.bTransparency? 'yellow':'lightgray'} />

          <SwitchNE style={{marginTop:0, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: "#dcdcdc", true: "palegreen" }}
            ios_backgroundColor="white"
            onValueChange={(value)=> {ConnectionOrd.ChangeTransparency(value)}}
            value={FontInfo.bTransparency}
          />
          </View>


          <Text style={[FontInfo.appStyles.txt_bold, {fontSize:16, marginTop:10, marginBottom:10, color:'rgba(255,255,255,.9)'}]}>Dark Mode</Text>
          <View style={{backgroundColor:'transparent', justifyContent:'center', marginBottom:10, alignItems:'center', alignContent:'center', flexDirection:'row'}}>
          {/* <Ionicons name="sunny" size={24} color="yellow" /> */}
          
          <View style={{marginTop:4, backgroundColor:'transparent', justifyContent:'center', width:24, height:24}}>
            <SvgDarkMode scale={.9} color={FontInfo.bDarkMode? 'yellow':'darkgray'}  />
           </View>

          {/* <MaterialCommunityIcons name="weather-night" size={22} color={FontInfo.bDarkMode? 'yellow':'lightgray'} /> */}

          <SwitchNE style={{marginTop:0, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: "#dcdcdc", true: "palegreen" }}
            ios_backgroundColor="white"
            onValueChange={(value)=> {ConnectionOrd.ChangeBackground(value)}}
            value={FontInfo.bDarkMode}
          />
          </View>


          <Text style={[FontInfo.appStyles.txt_bold, {fontSize:16, marginTop:10, marginBottom:10, color:'rgba(255,255,255,.9)'}]}>Auto Reconnect</Text>
          <View style={{backgroundColor:'transparent', justifyContent:'center', marginBottom:10, alignItems:'center', alignContent:'center', flexDirection:'row'}}>
          <View style={{backgroundColor:'transparent', flexDirection:'row'}}>

          <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:Connection.iReconType==Connection.RECON_OFF? '#03c04a' : 'rgba(105,105,105,.6)', margin:5,}} //'rgba(152,251,152,.9)'
              onPress={()=>
                {
                  ConnectionOrd.ChangeReconnType(Connection.RECON_OFF);
                  this.setState({update:this.state.update + 1});
                }}> 
              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:8, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Off</Text>
            </TouchableOpacity>


            <TouchableOpacity style={{borderRadius:5, 
                backgroundColor:Connection.iReconType==Connection.RECON_1MIN? '#03c04a' : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>
                {
                  ConnectionOrd.ChangeReconnType(Connection.RECON_1MIN);
                  this.setState({update:this.state.update + 1});
                }}> 
                <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:8, minWidth:40, color:'rgba(255,255,255,.8)'}]}>1 Min</Text>
             </TouchableOpacity>

            {/* <TouchableOpacity style={{borderRadius:5, 
                backgroundColor:Connection.iReconType==Connection.RECON_3MIN? '#03c04a' : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>
                {
                  ConnectionOrd.ChangeReconnType(Connection.RECON_3MIN);
                  this.setState({update:this.state.update + 1});                  
                }}> 
                <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>3 Min</Text>
             </TouchableOpacity> */}

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:Connection.iReconType==Connection.RECON_5MIN? '#03c04a' : 'rgba(105,105,105,.6)', margin:5,}}
             onPress={()=>
              {
                ConnectionOrd.ChangeReconnType(Connection.RECON_5MIN);
                this.setState({update:this.state.update + 1});                
              }}> 

              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:8, minWidth:40, color:'rgba(255,255,255,.8)'}]}>5 Min</Text>
            </TouchableOpacity>


          </View>
          </View>


          <Text style={[FontInfo.appStyles.txt_bold, {fontSize:16, marginTop:10, marginBottom:10, color:'rgba(255,255,255,.9)'}]}>Event Trading Advert</Text>
          <View style={{backgroundColor:'transparent', justifyContent:'center', marginBottom:10, alignItems:'center', alignContent:'center', flexDirection:'row'}}>

          <SwitchNE style={{marginTop:0, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: "#dcdcdc", true: "palegreen" }}
            ios_backgroundColor="white"
            onValueChange={(value)=> 
              {
                ConnectionOrd.ChangeEventTradeAdv(value)
                this.setState({update:this.state.update + 1});
              }}
            value={AppMain.bEventTradeAdv}
          />
          </View>


          </View>

          {/* <View style={{marginTop:10, marginLeft:40, flexDirection:'column'}}> */}
          <View style={{marginLeft:40, marginTop:10, flexDirection:'column'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {alignSelf:'center', fontSize:16, marginTop:5, marginBottom:10, color:'rgba(255,255,255,.9)'}]}>Text Size</Text>

            <View style={{marginTop:5, alignSelf:'center', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
             <TouchableOpacity style={{minWidth:40, minHeight:40, borderRadius:20, borderWidth:0, 
                                       alignItems:'center', justifyContent:'center', marginHorizontal:2,
                                       //borderColor:FontInfo.iFontSize==12?'lightgreen':'transparent',
                                       backgroundColor:'rgba(114,114,114,.3)'}}
              onPress={()=>{ FontInfo.SetFontSize(12); ConnectionOrd.ChangeFont(); }}
              >
              <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.iFontSize==12?'lightgreen':'white', fontSize:12, marginHorizontal:5}]}>A</Text> 
             </TouchableOpacity>


             <TouchableOpacity style={{minWidth:40, minHeight:40, borderRadius:20, borderWidth:0, 
                                       alignItems:'center', justifyContent:'center', marginHorizontal:2,
                                       //borderColor:FontInfo.iFontSize==13?'lightgreen':'transparent',
                                       backgroundColor:'rgba(114,114,114,.3)'}}              
              onPress={()=>{ FontInfo.SetFontSize(13); ConnectionOrd.ChangeFont(); }}>
              <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.iFontSize==13?'lightgreen':'white', fontSize:16, marginHorizontal:5}]}>A</Text> 
              </TouchableOpacity>


              <TouchableOpacity style={{minWidth:40, minHeight:40, borderRadius:20, borderWidth:0, 
                                       alignItems:'center', justifyContent:'center', marginHorizontal:2,
                                       //borderColor:FontInfo.iFontSize==14?'lightgreen':'transparent',
                                       backgroundColor:'rgba(114,114,114,.3)'}}
              onPress={()=>{ FontInfo.SetFontSize(14); ConnectionOrd.ChangeFont(); }}>
              <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.iFontSize==14?'lightgreen':'white', fontSize:20, marginHorizontal:5}]}>A</Text> 
              </TouchableOpacity>
            </View>


            <Text style={[FontInfo.appStyles.txt_bold, {alignSelf:'center', fontSize:16, marginTop:20, color:'rgba(255,255,255,.9)'}]}>Font</Text>
            <View style={{marginTop:0, width:260, flexWrap:'wrap', flexDirection:'row'}}>
            {
            FontInfo.Fonts.map((value, index) => {  
                return(
                      <TouchableOpacity key={index}
                                        style={{margin:5, minHeight:35, minWidth:55, backgroundColor:'transparent',
                                                justifyContent:'center', alignItems:'center', 
                                                borderRadius:10, flexDirection:'column'}}

                        onPress={()=>{ FontInfo.SetFont(index); ConnectionOrd.ChangeFont(); }}
                        >

                        <View style={{backgroundColor:'transparent', justifyContent:'center', }}>
                        <Text 
                              style={value.bold? {
                                      alignSelf:'center', 
                                      textAlign:'center', 
                                      paddingHorizontal:4,
                                      fontFamily:value.bold, fontSize:20, color:FontInfo.iFont==index?'lightgreen':'white'} :

                                      {alignSelf:'center', fontWeight:'bold', paddingHorizontal:4,
                                       textAlign:'center', fontSize:20, color:FontInfo.iFont==index?'lightgreen':'white'}}>Q90</Text>
                        </View>

                        {/* <View style={{width:70, height:30, backgroundColor:'rgba(255,255,255,.9)', justifyContent:'center', borderBottomLeftRadius:8, borderBottomRightRadius:8}}>
                        <Text key={value.normal}
                              style={{
                                      alignSelf:'center',
                                      textAlign:'center', 
                                      fontFamily:value.bold, fontSize:15, color:'black'}}>139.50</Text>
                        </View> */}

                      </TouchableOpacity>                                    
                      )
            
            })
            }
            </View>                        

          </View>
          
          </ScrollView>
          );
  }

  /*   -------------------------------------------------------------------   */

  copyLog = () => 
  {
  this.copyToClipboard(

            StringTable.APP_NAME_PRO + " " +  StringTable.APP_VERSION + " (" +
            Connection.DEVICE_NAME + ")\n" +  
            "Current Time is " + Utilities.formatTimeStatusbar(Date.now()) + "\n\n" +


            "Device: " + Device.modelName + "\n" +
            "OS: " + Device.osName + " v" + Device.osVersion + (Device.platformApiLevel? " SDK v" + Device.platformApiLevel : "") + "\n\n" + 
            

            "User: " + ConnectionMkt.oConn?.sUsr + "\n" +
            "System: " + Connection.sDisplaySystem + " (" + Connection.sDisplayGwy + ")\n" +


            "\n[Order]\n" +
            "Logged in: " + ConnectionOrd.oConn?.sSessionTime + "\n" + 
            "Session: " + ConnectionOrd.oConn?.sSession + "\n" + 
            "Last Reject: " + ConnectionOrd.oConn?.sLastReject + "\n" + 

            "\n[RMS]\n" +
            "Logged in: " + ConnectionRMS.oConn?.sSessionTime + "\n" + 
            "Session: " + ConnectionRMS.oConn?.sSession + "\n" + 
            "Last Reject: " + ConnectionRMS.oConn?.sLastReject + "\n" + 

            "\n[Market]\n" +
            "Logged in: " + ConnectionMkt.oConn?.sSessionTime + "\n" + 
            "Session: " + ConnectionMkt.oConn?.sSession + "\n" + 
            "Last Reject: " + ConnectionMkt.oConn?.sLastReject + "\n" + 

            "\n[History]\n" +
            "Logged in: " + ConnectionHis.oConn?.sSessionTime + "\n" + 
            "Session: " + ConnectionHis.oConn?.sSession + "\n" + 
            "Last Reject: " + ConnectionHis.oConn?.sLastReject + "\n"

    );
  };

  /*   -------------------------------------------------------------------   */

  copyToClipboard = async (sLog : string) => 
  {
    await Clipboard.setStringAsync(sLog);
  };

  /*   -------------------------------------------------------------------   */

  renderHelp()
  {
  const SIZE=40;

  if (this.state.tab != ReOrderEx.TAB_HELP)
    return(null);
  else
    return(
        // <View style={{marginLeft:40, marginTop:20, alignSelf:'center', flexDirection:'column', alignItems:'center',
        //               backgroundColor:'rgba(255,255,255,.0)', borderRadius:20, width:'100%'}}>

      <View style={{marginLeft:40, marginTop:20, flexDirection:'column', alignItems:'center',
                    backgroundColor:'rgba(255,255,255,.0)', borderRadius:20, width:285}}>

      <Text style={[FontInfo.appStyles.txt_bold, {margin:5, marginTop:5, fontSize:16, 
                    color:'white', opacity:.9}]}>Rithmic Trader Pro v{StringTable.APP_VERSION}</Text>

      <Text style={[FontInfo.appStyles.txt_normal, {marginTop:20, color:'lightgray', opacity:.9}]}>Connected to</Text>
      <Text style={[FontInfo.appStyles.txt_bold, {margin:5, marginTop:5, fontSize:16, 
                    color:'white', opacity:.9}]}>{Connection.sDisplaySystem}</Text>
      <Text style={[FontInfo.appStyles.txt_bold, {margin:5, marginTop:0, fontSize:16, 
                    color:'white', opacity:.9}]}>{Connection.sDisplayGwy}</Text>

        <Text style={[FontInfo.appStyles.txt_normal, {marginTop:20, color:'lightgray', opacity:.9}]}>Contact Us</Text>
        <Text style={[FontInfo.appStyles.txt_bold, {margin:5, fontSize:16, 
                      color:'lightgreen', opacity:.9}]}>support@rithmic.com</Text>
        <TouchableOpacity style={{margin:5, marginTop:0, opacity:.9}}
          onPress={()=>{
                        this.copyLog();
                        }}
          >
          <Text style={[FontInfo.appStyles.txt_bold, {fontSize:14, marginTop:20, color:'white', opacity:.9}]}>Copy Log</Text>
        </TouchableOpacity>


        {/* <ReleaseNotes ref={(node)=>this.oNotes = node} /> */}

        <TouchableOpacity style={{margin:5, marginTop:20, opacity:.9}}
          onPress={()=>{
                        this.CloseModal(false);
                        if (this.OnPopupMsg) this.OnPopupMsg(ReOrderEx.MSG_ABOUT); 
                        }}
          >
          <Text style={[FontInfo.appStyles.txt_bold, {fontSize:14, marginTop:20, color:'white', opacity:.9}]}>Release Notes</Text>
        </TouchableOpacity>

          {/* <View  style={{backgroundColor:'white', width:200, height:100}}></View> */}
        </View>
        );
  }

  /*   -------------------------------------------------------------------   */

  renderUser()
  {
  const SIZE=40;

  if (this.state.tab != ReOrderEx.TAB_USER)
    return(null);
  else
    return(
        <ACC bindEvent={this.props.bindEvent}/>
        );
  }

  /*   -------------------------------------------------------------------   */

  onDragEnd(positions)
  {
    //Utilities.Sendlog( JSON.stringify(positions, null, 2) );
    oSettAlt = new Array(this.oSymList.length);
    

    if (__DEV__)
      Utilities.Sendlog("positions: " + positions);

    for (let i = 0; i < this.oSymList.length; i++)
    {
    let iNew       = positions[i.toFixed()];

    //if (this.oSymList[i].token)
      oSettAlt[iNew] = this.oSymList[i];
    }

    //this.oSymList = oSettAlt.slice();

    if (__DEV__)
      {
      Utilities.Sendlog("new positions: " + positions);

      for (let i = 0; i < this.oSymList.length; i++)
        {
        Utilities.Sendlog( this.oSymList[i].token );
        }
      } 
    
  this.setState({scroll_enabled:true});  
  }

  /*   -------------------------------------------------------------------   */

  renderSortable()
  {
  return(
      <SortableContainer key={this.state.update} customconfig={{ COL: 1, MARGIN: 10, SIZE: 100, }} >
          
          <SortableGrid
          key={this.state.update}
          editing={true}
          // onPress={(x, y, token) => { 
          //       console.log("press: " + token + " " + x + ", " + y);
          //       //this.setState({scroll_enabled:false});
          //       }}

          onPressEnd={(token: string)=>{ /*ConnectionOrd.NavigateTo(Number.parseInt(id))*/ }}
          onDragEnd={this.onDragEnd}
          >
          {this.oSymList.map((tile, index) => 
              (
              <SortableTile
              //style={{width: 2000, height:1000}}
              onLongPress={() => true}
              
              key={index}
              token={tile.token}
              
              id={index.toString()}
              >
              <View style={[{marginLeft:10, width: 250, flexDirection:'row', backgroundColor:'rgba(255,255,255,0.8)', 
                             borderRadius:15, justifyContent:'center'
                            }]}>

                  {/* <View style={{width: 25, height:'90%', backgroundColor:'rgba(255, 255,255, .8)', opacity:1, 
                                borderTopLeftRadius:15, borderBottomLeftRadius:15, justifyContent:'center'}}>
                  <View style={{alignItems:'center', alignSelf:'center', justifyContent:'center', marginBottom: 0,}}>
                  <MaterialCommunityIcons style={{marginLeft:4, marginRight:2}} name="swap-vertical-circle" size={20} color="rgba(0,0,0,.8)" />
                  </View>
                  </View> */}


                  {/* <View style={{width: 225, height:'90%', backgroundColor:'rgba(255,255,255,0.8)', 
                                borderRadius:15, justifyContent:'center'}} > */}

                  

                  <Pressable style={{flexDirection:'row', flex:1, alignItems:"center"}}
                  
                  //  onPressIn={(e)=>{  
                  //   this.setState({scroll_enabled:false});

                  //   }}

                   onPress={(event: GestureResponderEvent)=>
                    {
                      // if (event?.nativeEvent?.locationX != undefined && 
                      //     event?.nativeEvent?.locationX >= 0 && 
                      //     event?.nativeEvent?.locationX <= 30)
                      //   {
                      //   alert(event?.nativeEvent?.locationX)
                      //   return;
                      //   }

                      let z = Utilities.FindItem(Connection.oSettings, tile.token); 
                      
                      if (z != AppMain.IMAGINARY) ConnectionOrd.NavigateTo(z); /*this.CloseModal(false);*/
                      //event.stopPropagation(); 
                    }}
                   >

                  <TouchableOpacity style={{minWidth:30, justifyContent:'center', minHeight:25, backgroundColor:'transparent'}}
                  onPress={()=>
                    {
                      Utilities.FindAndDeleteItem(this.oSymList, tile.token);
                      oSettAlt      = this.oSymList.slice();
                      this.setState({del_index:AppMain.IMAGINARY, update:this.state.update + 1});
                    }}
                   >
                   <AntDesign name="closecircle" style={{alignSelf:'center'}} size={17} color={"rgba(24,24,24,.4)"} />
                  {/* <MaterialCommunityIcons style={{alignSelf:'flex-start', marginLeft:4, marginRight:2}} name="swap-vertical-circle" size={20} color="rgba(0,0,0,.8)" /> */}
                  </TouchableOpacity> 

                  <Text style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', margin:3, paddingHorizontal:0, paddingTop:0,  
                                textAlign:'left', textAlignVertical:'center', justifyContent:'center', color:'black', }]}>{tile.token}</Text>

                  



                  <TextNC ref={(node)=>this.oNC.push(node)} oData={ConnectionMkt.oStore.get(tile.token)}/>
                  <TextPC ref={(node)=>this.oPC.push(node)} oData={ConnectionMkt.oStore.get(tile.token)}/>


                  {/* <Pressable style={{position:'absolute', right:0, minWidth:40, marginTop:2, justifyContent:'center'}}> */}
                  {/* <AntDesign name="closecircle" style={{position:'absolute', right:4, alignSelf:'center'}} size={17} color={"rgba(44,44,44,.4)"} /> */}
                  {/* </Pressable> */}

                  </Pressable>

                  {/* </View> */}

              </View>
              </SortableTile>
          ))}

          </SortableGrid>
      </SortableContainer>

  );  
  }

  /*   -------------------------------------------------------------------   */

  renderEdit()
  {
  //  return(null);

  if (this.state.tab != ReOrderEx.TAB_EDIT)
    return(null);
  else
    return(
      <View style={{flex:1, flexDirection:'column',}}>
        
      {/* <View style={{flex:1, marginLeft:35, marginTop:20}} key={this.state.update}> */}

      <View style={{flex:1, marginLeft:35, marginTop:20, backgroundColor:'transparent'}} key={this.state.update}>
        <this.renderSortable/>
      </View>

      {/* <View style={{flex:1, marginLeft:0, marginTop:20, backgroundColor:'transparent'}} key={this.state.update}>

      </View> */}



      <View style={{flexDirection:'column', alignSelf:'center', width:'100%', backgroundColor:'transparent'}}>
      {/* <View style={{alignSelf:'center', flexDirection:'row', marginTop:4, marginBottom:4, marginLeft:25, }}> */}
      <View style={{alignSelf:'center', flexDirection:'row', marginTop:4, marginBottom:4, marginLeft:25, }}>
      <TouchableOpacity style={{margin:5, alignItems:'center', justifyContent:'center', borderRadius:20, width:40, 
                                  minHeight:40, backgroundColor:'rgba(0,0,0,.7)'}}

                                  onPress={()=>
                                    {
                                    this.oSymList = Connection.GetSymbols(this.oSymList, 1)
                                    oSettAlt      = this.oSymList.slice();
                                    this.setState({del_index:AppMain.IMAGINARY, update:this.state.update + 1});
                                    }}
                       
                                  >
        {/* <MaterialCommunityIcons name="sort-alphabetical-ascending" size={22} color="rgba(255, 255,255, .8)" />  */}
        <View style={{width:22, height:22}}>
        <SvgSortAZ scale={.9} color="rgba(255, 255,255, .8)"/>
        </View>

        </TouchableOpacity>

        <TouchableOpacity style={{margin:5, alignItems:'center', justifyContent:'center', borderRadius:20, width:40, 
                                 minHeight:40, backgroundColor:'rgba(0,0,0,.7)'}}

                                 onPress={()=>
                                  {
                                  this.oSymList = Connection.GetSymbols(this.oSymList, 2);
                                  oSettAlt      = this.oSymList.slice();

                                  this.setState({del_index:AppMain.IMAGINARY, update:this.state.update + 1});
                                  }}

                                 >
        {/* <MaterialCommunityIcons name="sort-alphabetical-descending" size={22} color="rgba(255, 255,255, .8)" /> */}

        <View style={{width:22, height:22}}>
        <SvgSortZA scale={.9} color="rgba(255, 255,255, .8)"/>
        </View>

        </TouchableOpacity>


      <TouchableOpacity
      style={[{//marginTop:12, marginBottom:8, marginLeft:25, paddingHorizontal:10, paddingVertical:5, 
               margin:5,
               minWidth:40,
               minHeight:40,
               borderRadius:20, alignSelf:'center', alignItems:'center', flexDirection:'row',
               alignContent:'center', justifyContent:'center', backgroundColor: 'rgba(0,0,0,.7)'}]}

      onPress={()=>
          {
          this.CloseModal(false);
          if (this.OnPopupMsg) this.OnPopupMsg(ReOrderEx.MSG_SEARCH); 
          }}
      >
      <FontAwesome style={{ marginBottom: -3 }}  name="plus" size={15} color="rgba(255, 255,255, .8)" />
      {/* <Text style={{color:'white', fontSize:14, fontWeight:'bold', minWidth:20, marginLeft:5}}></Text> */}
      </TouchableOpacity>
      </View>



      <View style={{ flexDirection:'row', alignSelf:'flex-end', alignItems:'center', justifyContent:'center', width:'100%', 
                     borderBottomEndRadius:25, backgroundColor:'rgba(94,94,94,.8)'}}>
      <View style={{marginLeft:20, flexDirection:'column', alignSelf:'center', justifyContent:'center', backgroundColor:'transparent'}}>
        
      <TouchableOpacity
      style={[{marginTop:8, marginBottom:8, marginRight:0, width:60, height:60, borderRadius:30, alignSelf:'center', 
              alignItems:'center', alignContent:'center', justifyContent:'center', backgroundColor: 'cornflowerblue'}]}

      onPress={()=>
          {
          this.CloseModal(true);
          //GetSymbolInfo(m_get_txt()); 
          }}
      >
      <Ionicons style={{ marginBottom: 0, }} name="checkmark-sharp" size={30} color="white" />
      </TouchableOpacity>
      </View>
      </View>

      </View>

      </View>
      );
  }

  /*   -------------------------------------------------------------------   */

  render() 
   {
    this.oPC.splice(0, this.oPC.length);
    this.oNC.splice(0, this.oNC.length);
  
    //Utilities.Sendlog(JSON.stringify(this.oSymList));

    if (!this.state.visible) 
    return(null);
    else  
    return(
        <>
        <AnimatedPressable
        onPress={this.Hide}
        // style={this.state.visible == false? {display:'none'} : {position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'black', opacity: this.state.AnimOp, top:0, bottom:0}}
        style={{position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'black', opacity: this.state.AnimOp, top:0, bottom:0}}
        >

        <View />
        </AnimatedPressable>

        {/* <Animated.View style={!ConnectionOrd.oConn?.GetLoginStatus()? {display: "flex"} :  */}
        <Animated.View style={
            {
              //{[styles.loadAmount, {transform: [{translateX: this.animatedValue}]}]}  
            paddingTop:30, marginTop:0, marginBottom:0, display: "flex", 
            zIndex:200, 
            
            position:'absolute', left:0, top:40, bottom:0, 
            width:DEFAULT_WIDTH - 25, 
            flexDirection:'column', justifyContent:'flex-start', 
                      
            backgroundColor:FontInfo.bTransparency?'rgba(54, 54, 54, .8)' : 'rgba(54, 54, 54, 1)', 
              
            
            //marginLeft:this.state.AnimLeft, 
            transform: [{translateX: this.state.AnimLeft}],

            borderTopEndRadius:25, borderBottomEndRadius:25,
            }}>



        <this.renderTop/>

        <this.renderEdit/>
        <this.renderSettings/>
        <this.renderUser/> 
        <this.renderHelp/>
        

        </Animated.View>
        </>
        ); 

   }
}

/*   =====================================================================   */

const styles = StyleSheet.create({

    container_sort_cover: {
      backgroundColor: 'transparent',
      alignSelf:'center',
      width:200,
    },
  
    container_sort: {
      backgroundColor: 'transparent',
      alignSelf:'center',
    },
  
    tile_sort: {
      backgroundColor:'transparent',
      width: '100%',
      height: '100%',
    },
});